document.addEventListener('DOMContentLoaded', function() {

  var body = document.querySelector('body');
  body.classList.remove('preload');

  /////////////////////////// Open/close mobile nav //////////////////////
  var open_mobile_nav = document.querySelector('[data-action="open-mobile-nav"]');

  open_mobile_nav.addEventListener('click', function() {
    var mobile_nav = document.querySelector('.mobile-nav');
    var overlay = document.querySelector('.overlay');

    mobile_nav.classList.add('mobile-nav--shown');
    overlay.classList.add('overlay--shown');
  });


  var close_triggers = document.querySelectorAll('[data-action="close-mobile-nav"]');

  for (var j = 0; j < close_triggers.length; j++) {
    var close_trigger = close_triggers[j];
    close_trigger.addEventListener('click', function() {
      close_mobile_nav();
    });
  }

  function close_mobile_nav(){
    var mobile_nav = document.querySelector('.mobile-nav');
    var overlay = document.querySelector('.overlay');

    mobile_nav.classList.remove('mobile-nav--shown');
    overlay.classList.remove('overlay--shown');
  }


  ///////////// Scroll to nav /////////////////////
  var scroll_to_links = document.querySelectorAll('[data-scroll-to]');

  for (var k = 0; k < scroll_to_links.length; k++) {
    var scroll_to_link = scroll_to_links[k];

    scroll_to_link.addEventListener('click', function(event) {
      if('scrollBehavior' in document.documentElement.style) {
        event.preventDefault();

        var anchor = this.getAttribute('href');
        var anchor_elem =  document.querySelector(anchor);

        scroll_to(anchor_elem);
      }else {
        close_mobile_nav();
      }
      
    });
  }

  function scroll_to(element) {
    var scroll_value = element.offsetTop - 78;
    
    window.scrollTo({
      top: scroll_value,
      left: 0,
      behavior: 'smooth',
    });

    close_mobile_nav();
  }

  ///////////// navigation item active trigger /////////////////////
  var navlinks = document.querySelectorAll('.navigation__link');
  var anchor_elems = [];
  for (k = 0; k < navlinks.length; k++) {
    var navlink = navlinks[k];

    var anchor = navlink.getAttribute('href');

    anchor_elems.push({
      content_item: document.querySelector(anchor),
      nav_item: navlink,
    });
  }

  window.addEventListener('scroll', function() {
    activate_nav_anchor();
  });

console.log(anchor_elems);
  function activate_nav_anchor(){
    for (k = 0; k < anchor_elems.length; k++) {
      var anchor_elem = anchor_elems[k];

      var anchor_top_position = anchor_elem.content_item.offsetTop;

      if( anchor_top_position >= window.pageYOffset && anchor_top_position < window.pageYOffset + window.innerHeight/2)
      {
        for (var index = 0; index < anchor_elems.length; index++) {
          anchor_elems[index].nav_item.classList.remove('navigation__link--active');
        }
        anchor_elem.nav_item.classList.add('navigation__link--active');
        console.log(anchor_elem);

      }
    }
  }

  ////////////////////////// Header fixed/absolute //////////////////////

  var intro = document.querySelector('.intro');
  var header = document.querySelector('.header');

  window.addEventListener('scroll', function() {
    var viewportOffset = intro.getBoundingClientRect();
    // these are relative to the viewport, i.e. the window
    var bottom = viewportOffset.bottom;
    
    if(!header.classList.contains('header--fixed') && bottom < 0) {

      header.classList.add('header--slide-up');

      setTimeout(function(){
        header.classList.add('header--fixed');
        header.classList.add('header--slide-down');
        header.classList.remove('header--slide-up');
      }, 200);
    }else if(header.classList.contains('header--fixed') && bottom > 0){
      header.classList.add('header--slide-up');

      setTimeout(function(){
        header.classList.remove('header--slide-down');
      }, 1);

      setTimeout(function(){
        header.classList.remove('header--fixed');
        header.classList.remove('header--slide-up');
      }, 200);
    }

  });


  ///////////////////////// GMAP ///////////////////////////////////////

  // eslint-disable-next-line no-unused-vars
  var map, marker;
  var center = {
    lat: 35.662603954358616,
    lng: 139.69428592836758, 
  };

  // eslint-disable-next-line no-unused-vars
  function initMap() {
    // eslint-disable-next-line no-undef
    var map = new google.maps.Map(document.getElementById('map'), {
      center: center,
      zoom: 18,
      styles:[
        {
          'stylers': [
            {
              'hue': '#15246d',
              //'saturation': -100,
            },
          ],
        },
      ],
    });

    // eslint-disable-next-line no-undef
    marker = new google.maps.Marker({
      position: center,
      map: map,
    });

  }
  window.initMap = initMap;


  ////////////////////////////// Lazyload ///////////////////////////////////


  //Handling lazyload
  const targets = document.querySelectorAll('[data-lazy-srcset], [data-lazy-src]');

  //lazy loading currently deactivated because it was messing up anchor links
  if ('IntersectionObserver' in window && 0) {
    var config = {
      // If the element gets within 10px in the Y axis, start the animation.
      rootMargin: '400px 0px 400px 0px',
      threshold: 0.01,
    };

    let lazyload_observer = new IntersectionObserver(function on_intersection(entries){
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          const img = entry.target;
          const src = img.getAttribute('data-lazy-src');

          if(null != src) {
            img.setAttribute('src', src);
          }

          const srcset = img.getAttribute('data-lazy-srcset');
          if(null != srcset) {
            img.setAttribute('srcset', srcset);
          }

          lazyload_observer.unobserve(img);
        }
      });
    }, config);

    targets.forEach(function(target) {
      lazyload_observer.observe(target);
    });
  } else {

    for (var i = 0; i < targets.length; i++) {
      var target = targets[i];
      const src = target.getAttribute('data-lazy-src');

      if(null != src) {
        target.setAttribute('src', src);
      }
    
      const srcset = target.getAttribute('data-lazy-srcset');
      if(null != srcset) {
        target.setAttribute('srcset', srcset);
      }
    }
  }




  ////////////////////////////////// Animation triggers /////////////////////////////////////////


  var items_to_animate = [].slice.call(document.querySelectorAll('[data-animate]'));

  if ('IntersectionObserver' in window) {
    var configAnimation = {
      // If the element gets within 10px in the Y axis, start the animation.
      rootMargin: '0px 0px 200px 0px',
      threshold: 0.01,
    };

    let animation_observer = new IntersectionObserver(function on_intersection(entries){
      entries.forEach(function(entry) {

        //we check the type of animation to see if it should only triggered once or not
        var animation_type = entry.target.dataset.animate;

        if (entry.isIntersecting) {
          //element is in the view so we start the animation
          entry.target.classList.add('animated');

          //If the animation should be done only once, remove the observer
          if(animation_type == 'once')
          {
            animation_observer.unobserve(entry.target);
          }
        }else{

          if( animation_type != 'once'){
            //If the animation have to be triggered again
            entry.target.classList.remove('animated');
          }
        }

      });
    }, configAnimation);

    items_to_animate.forEach(function(item_to_animate) {
      animation_observer.observe(item_to_animate);
    });
  }else{
    //fallback
    items_to_animate.forEach(function (){
      this.target.classList.add('animated');
    })
  }

});


// WEBPACK FOOTER //
// ./scripts/main.js